import { useEffect, useRef, useState } from 'react'

const reduced = () => typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches

/** Animates a number from its previous value to the target (ease-out, ~700ms). */
export function useCountUp(target: number | null | undefined, duration = 700) {
  const [value, setValue] = useState(target ?? 0)
  const from = useRef(0)
  useEffect(() => {
    if (target == null || Number.isNaN(target)) return
    // Hidden tabs don't run animation frames: show the final value immediately.
    if (reduced() || document.hidden) {
      from.current = target
      return setValue(target)
    }
    const start = performance.now()
    const origin = from.current
    let frame = 0
    const tick = (now: number) => {
      const t = Math.min(1, (now - start) / duration)
      const eased = 1 - Math.pow(1 - t, 3)
      setValue(origin + (target - origin) * eased)
      if (t < 1) frame = requestAnimationFrame(tick)
      else from.current = target
    }
    frame = requestAnimationFrame(tick)
    const settle = setTimeout(() => { setValue(target); from.current = target }, duration + 150)
    return () => {
      cancelAnimationFrame(frame)
      clearTimeout(settle)
    }
  }, [target, duration])
  return value
}
